import React from 'react';
export function HeroSection() {
  return <div className="relative bg-brand-dark text-white py-32 md:py-48 overflow-hidden" data-id="element-155">
      {/* Video Background */}
      <div className="absolute inset-0 z-0" data-id="element-156">
        <div className="absolute inset-0 bg-black/60 z-10" data-id="element-157"></div>
        <video autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-158">
          <source src="https://www.websiteforge.net/custom/SpedUpLapse.mp4" type="video/mp4" data-id="element-159" />
        </video>
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-160">
        <h1 className="text-4xl md:text-6xl font-bold mb-8 tracking-tight" data-id="element-161">
          Built for Professionals
        </h1>
        <div className="max-w-3xl mx-auto space-y-6" data-id="element-162">
          <p className="text-xl md:text-2xl text-gray-200 font-medium leading-relaxed" data-id="element-163">
            We don't build toys. We build tools for contractors who depend on
            their gear to make a living.
          </p>
          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-164">
            Precision Pro Sprayers was founded with a simple goal: eliminate the
            frustrations that slow contractors down. We saw professionals
            struggling with battery failures, heavy lifting, and messy chemical
            transfers.
          </p>
          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-165">
            The ForceX product line is our answer. By focusing on corded
            electric power and siphon-based systems, we've removed the weak
            points of traditional sprayers. No batteries to die in the middle of
            a job. No tanks to carry on your back. Just reliable, continuous
            pressure.
          </p>
        </div>
      </div>
    </div>;
}